export const initialUserPreferences = {
  clientsColors: [
    '#8a3636',
    '#36898a',
    '#cba321',
    '#012e5a',
    '#af8989',
    '#4e4e4e',
    '#4a8a36',
    '#A9C',
    '#9CA',
    '#A30',
    '#D54',
  ],
  weekOfWork: [
    { day: 0, hours: [9, 18] },
    { day: 1, hours: [9, 18] },
    { day: 2, hours: [9, 18] },
    { day: 3, hours: [9, 18] },
    { day: 4, hours: [9, 17] },
  ],
  break: [13, 14],
  step: 0.25,
};
